import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const EcommerceAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.ecommerce} />

export default EcommerceAppDevelopment
